import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";
import TypographyStyle from "@assets/typography";

const useStyles = CreateResponsiveStyle(
  {
    index_container: { flexGrow: 1,},
    left_container: {
      width: 240,
      height: "97%",
      paddingTop: 10,
      paddinghorizontal: 10,
      borderRightWidth: .5,
    },
    t_title_left: {
      ...TypographyStyle.heading2Bold, 
      fontSize: 16,
      lineHeight: 10.5,
      textAlign: "left",
    },
    t_subtitle_left: {
      ...TypographyStyle.heading6Regular, 
      flex: 1,
      fontSize: 11,
      lineHeight: 13.5,
      marginTop: 13,
      marginBottom: 20,
      textAlign: "left",
    },
    public_view_cointainer: { flex: 1, paddingHorizontal: 70 },
    container: { flex: 1, flexDirection: "row" },
    body_style: { flex: 1, alignItems: "flex-start" },
    v_height: { height: 40 },
  },
  {
    [DEVICE_SIZES.LG]: {
      public_view_cointainer: { flex: 1, paddingHorizontal: 50 },
      v_height: { height: 30.75 },
    },
    [maxSize(DEVICE_SIZES.MD)]: {
      public_view_cointainer: { flex: 1, paddingHorizontal: 0 },
    },
  }
);

export default useStyles;
